import { Reveal, ChapterTag } from "./Reveal";

const PORTRAIT = "https://customer-assets-rejwkqb3.emergentagent.net/job_talk-it-out-ch/artifacts/zbryqciq_20250310_001022.webp";

const QUALS = [
    "Bachelor Sozialwissenschaften, Universität Zürich",
    "Master Soziale Arbeit – ZHAW, laufend",
    "Mehrjährige Erfahrung in der Beratung und Begleitung von Kindern, Jugendlichen und jungen Erwachsenen",
    "Erfahrung in der Arbeit mit jungen Menschen in belastenden Lebenssituationen und Krisen",
];

export const UeberMich = () => (
    <section id="ueber-mich" data-testid="ueber-mich-section" className="py-24 sm:py-32 lg:py-40 bg-[#F4F1EA]">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
            <div className="grid lg:grid-cols-12 gap-10 lg:gap-x-20 lg:gap-y-0 items-start">
                <Reveal className="order-1 lg:col-span-7 lg:col-start-6 lg:row-start-1">
                    <ChapterTag number="01" label="Über mich" />
                </Reveal>

                <Reveal className="order-2 lg:col-span-5 lg:col-start-1 lg:row-start-1 lg:row-span-2 lg:self-stretch">
                    <div className="relative max-w-md mx-auto lg:mx-0 lg:sticky lg:top-28">
                        <div className="border border-[#DDD6C8] p-3 bg-[#FAF8F5]">
                            <img
                                data-testid="ueber-mich-portrait"
                                src={PORTRAIT}
                                alt="Portrait von Fjona Gerber"
                                className="aspect-[4/5] w-full object-cover object-[50%_32%]"
                            />
                        </div>
                    </div>
                </Reveal>

                <div className="order-3 lg:col-span-7 lg:col-start-6 lg:row-start-2">
                    <Reveal>
                        <h2 data-testid="ueber-mich-name" className="font-serif font-light text-3xl sm:text-5xl tracking-tight text-[#2B2825]">
                            Hallo, ich bin Fjona.
                        </h2>
                        <div data-testid="ueber-mich-bio" className="mt-8 space-y-5 font-sans text-base sm:text-lg font-light leading-relaxed text-[#59534C]">
                            <p>
                                Seit mehreren Jahren arbeite ich mit Jugendlichen und jungen Erwachsenen, die sich in belastenden
                                Lebenssituationen oder Krisen befinden. Dabei habe ich schnell gemerkt, dass mir besonders
                                die persönliche Beratung und Begleitung am Herzen liegt.
                            </p>
                            <p>
                                Ich habe an der Universität Zürich einen Bachelor in Sozialwissenschaften mit den
                                Schwerpunkten Kommunikation und Soziologie abgeschlossen und studiere aktuell im Master
                                Soziale Arbeit.
                            </p>
                            <p>
                                In meiner bisherigen Arbeit habe ich immer wieder erlebt, wie hilfreich es sein kann, eine
                                Person ausserhalb des eigenen Umfelds zu haben, jemanden, der zuhört, ernst nimmt und
                                gemeinsam mit einem auf die aktuelle Situation schaut.
                            </p>
                            <p>
                                In meiner Beratung geht es nicht darum, dir zu sagen, was richtig oder falsch ist. Mir ist
                                wichtig, gemeinsam mit dir zu verstehen, was dich beschäftigt, deine eigenen Stärken und
                                Möglichkeiten sichtbar zu machen und Schritte zu entwickeln, die zu dir und deiner
                                Situation passen.
                            </p>
                        </div>
                    </Reveal>

                    <Reveal delay={0.15}>
                        <div className="mt-10 border-t border-[#DDD6C8] pt-8">
                            <p className="font-sans text-[11px] font-medium tracking-[0.25em] uppercase text-[#8C8275] mb-5">
                                Ausbildung & Erfahrung
                            </p>
                            <ul data-testid="ueber-mich-qualifikationen" className="space-y-3.5">
                                {QUALS.map((q) => (
                                    <li key={q} className="flex items-start gap-3 font-sans text-sm sm:text-base font-light text-[#2B2825]">
                                        <span className="w-2 h-2 bg-[#5E6B5A] shrink-0 mt-[0.45em]" />
                                        <span className="leading-snug">{q}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);
